<template>
  <div>
    <vs-button ref="loadBtn" color="secondary" type="border" @click="showLoadRiskPost = true">{{ $t('위험성평가 정보 불러오기') }}</vs-button>
    <p style="font-size: 16px; line-height: 17px" class="mb-5">※ [<b>{{ $t('위험성평가') }}</b>{{ $t('(유해·위험요인 파악) →') }}<b>{{ $t('위험성평가회의') }}</b>{{ $t('(위험성평가의 공유) →') }}<b>{{ $t('교육·TBM 전파') }}</b>{{ $t('(위험성 결정, 감소대책 수립) →') }}<b>{{ $t('이행확인') }}</b>{{ $t('(감소대책 실행)]') }}</p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="{ ...board, readonly: true }" :field-name="form.stdInfo.field_name" :is-print="isPrint"  />

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" readonly :is-print="isPrint"/>

    <!-- 주간 이행사항 점검 및 회의 -->
    <ImplementationTable :readonly="board.readonly" v-model="form.implement" class="mb-6" :is-print="isPrint"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- Post 불러오기 팝업 -->
    <PopupLoadPrevBoard :title="$t('위험성평가 정보 불러오기')" :setBoardId="475" v-model="showLoadRiskPost" @selectRowData="loadRiskPost" />
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import RiskTable from "../475/RiskTable.vue";
import ImplementationTable from "./ImplementationTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    RiskTable,
    ImplementationTable,
    DateSelector,
    FileUploader,
    PopupLoadPrevBoard,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      headerDate: { required },
      stdInfo: {
        field_name: { required },
      },
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        const year = value.year;
        const month = Number(`${value.month}`);
        this.form.headerDate = `${year}-${month < 10 ? `0${month}` : month}`;
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.implement': {
      deep: true,
      handler(value) {
        this.form.implementCheck = ""
        for(const implement of value) {
          this.form.implementCheck += `${implement.input2} `
        }

        this.$emit("input", this.form);
      },
    },
  },
  data() {
    return {
      showLoadRiskPost: false,
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskList: [],
        implement: [],

        implementCheck: "",

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",
      },
    };
  },
  mounted() {
    const buttonContainer = document.querySelector("#right-button-container");
    const loadBtn = this.$refs.loadBtn;
    buttonContainer.prepend(loadBtn.$el);
  },
  methods: {
    loadRiskPost(data) {
      this.form.headerDate = data.headerDate;
      this.form.stdInfo = data.stdInfo;
      this.form.riskList = data.riskList;

      this.form.inputA_1 = data.inputA_1;
      this.form.inputA_2 = data.inputA_2;
      this.form.inputA_3 = data.inputA_3;
      this.form.inputA_4 = data.inputA_4;
      this.form.inputA_5 = data.inputA_5;
      this.form.inputA_6 = data.inputA_6;
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "위험성평가 정보는 반드시 불러와야 합니다";
      }
    },

    translationMap() {
      const prefix = "위험성평가(3등급).주간 이행사항 점검 및 회의";

      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        [`${prefix}.위험성평가표`]: this.form.riskList.map((item) => {
          return {
            "공종분류": item.input1,
            "단위작업": item.input2,
            "위험요인": item.input3,
            "재해형태": item.input4,
            "위험성 결정.위험도 등급": item.input5,
            "위험방지대책": item.input6,
            "개선조치 담당자": item.input7,
            "개선조치 조치예정일": item.input8,
            "이행확인.근로자대표": item.input9,
            "이행확인.관리감독자": item.input10,
          }
        }),

        [`${prefix}.주간 이행사항 점검 및 회의`]: this.form.implement.map((item) => {
          return {
            "주간 위험성평가 결과 논의·공유 및 이행상황 점검": item.input2,
            "참석자1": item.input5,
            "참석자2": item.input6,
            "참석자3": item.input7,
            "참석자4": item.input8,
            "참석자5": item.input9,
            "참석자6": item.input10,
            "참석자7": item.input11,
            "참석자8": item.input12,
            "참석자9": item.input13,
            "참석자10": item.input14,
          }
        }),

      };

      return translateData;
    },
    translate(translate) {
      const prefix = "위험성평가(3등급).주간 이행사항 점검 및 회의";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];

      const riskList = translate[`${prefix}.위험성평가표`];
      const _riskList = JSON.parse(JSON.stringify(this.form.riskList));
      for (let i=0; i<riskList.length; i++) {
        _riskList[i].input1 = riskList[i]['공종분류'];
        _riskList[i].input2 = riskList[i]['단위작업'];
        _riskList[i].input3 = riskList[i]['위험요인'];
        _riskList[i].input4 = riskList[i]['재해형태'];
        _riskList[i].input5 = riskList[i]['위험성 결정.위험도 등급'];
        _riskList[i].input6 = riskList[i]['위험방지대책'];
        _riskList[i].input7 = riskList[i]['개선조치 담당자'];
        _riskList[i].input8 = riskList[i]['개선조치 조치예정일'];
        _riskList[i].input9 = riskList[i]['이행확인.근로자대표'];
        _riskList[i].input10 = riskList[i]['이행확인.관리감독자'];
      }
      this.$set(this.form, "riskList", _riskList);

      const implementList = translate[`${prefix}.주간 이행사항 점검 및 회의`];
      const _implementList = JSON.parse(JSON.stringify(this.form.implement));
      for (let i=0; i<implementList.length; i++) {
        _implementList[i].input2 = implementList[i]['주간 위험성평가 결과 논의·공유 및 이행상황 점검'];
        _implementList[i].input5 = implementList[i]['참석자1'];
        _implementList[i].input6 = implementList[i]['참석자2'];
        _implementList[i].input7 = implementList[i]['참석자3'];
        _implementList[i].input8 = implementList[i]['참석자4'];
        _implementList[i].input9 = implementList[i]['참석자5'];
        _implementList[i].input10 = implementList[i]['참석자6'];
        _implementList[i].input11 = implementList[i]['참석자7'];
        _implementList[i].input12 = implementList[i]['참석자8'];
        _implementList[i].input13 = implementList[i]['참석자9'];
        _implementList[i].input14 = implementList[i]['참석자10'];
      }
      this.$set(this.form, "implement", _implementList);
    },
  },
};
</script>
